import React from 'react';
import { Link } from 'react-router-dom';
import { FaTrophy, FaHistory, FaPlus, FaUserFriends, FaInfoCircle } from 'react-icons/fa';
import './Home.css';

const Home = () => {
  return (
    <div className="container">
      <div className="hero-banner">
        <div className="hero-content">
          <h1>ToggleBoys Discgolf League 2025</h1>
          <p>Tracking scores and standings across multiple courses</p>
          <div className="hero-buttons">
            <Link to="/standings" className="btn">
              <FaTrophy /> Visa ställning
            </Link>
            <Link to="/add-round" className="btn secondary">
              <FaPlus /> Registrera ny runda
            </Link>
          </div>
        </div>
      </div>

      <div className="home-grid">
        <div className="card feature-card">
          <div className="feature-icon">
            <FaTrophy />
          </div>
          <h3>Ställning</h3>
          <p>Se aktuell ligaställning och poängfördelning per bana.</p>
          <Link to="/standings" className="feature-link">
            Visa ställning
          </Link>
        </div>

        <div className="card feature-card">
          <div className="feature-icon">
            <FaHistory />
          </div>
          <h3>Rundor</h3>
          <p>Se historik över alla spelade rundor och detaljerade resultat.</p>
          <Link to="/rounds" className="feature-link">
            Visa rundor
          </Link>
        </div>

        <div className="card feature-card">
          <div className="feature-icon">
            <FaPlus />
          </div>
          <h3>Lägg till runda</h3>
          <p>Registrera nya rundor direkt i applikationen.</p>
          <Link to="/add-round" className="feature-link">
            Lägg till
          </Link>
        </div>

        <div className="card feature-card">
          <div className="feature-icon">
            <FaUserFriends />
          </div>
          <h3>Spelare</h3>
          <p>Se information om alla spelare i ligan.</p>
          <Link to="/players" className="feature-link">
            Visa spelare
          </Link>
        </div>
      </div>

      <div className="card info-card">
        <div className="info-header">
          <FaInfoCircle />
          <h3>Om PuttPals</h3>
        </div>
        <p>
          PuttPals är en applikation för att spåra och analysera resultat för ToggleBoys Discgolf League 2025. 
          En modern React-applikation med backend i Node.js och MySQL-databas.
        </p>
        <div className="info-details">
          <div className="info-item">
            <strong>Version:</strong> 2.0.0
          </div>
          <div className="info-item">
            <strong>Senaste uppdatering:</strong> {new Date().toLocaleDateString('sv-SE')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home; 